import React, { useState, useEffect } from 'react'

//Bibliotecas
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//Estilos
import "./ActividadOrdenar.scss";
//Componentes
import { CustomButton } from '../../common/Button';
//Imágenes
import { X, Check, HelpCircle } from 'react-feather';

//Reordenar Drag and Drop
const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

// Barajar array - Algoritmo Fisher-Yates
const shuffle = (arr) => {
    const array = arr.slice(0);
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};



function ActividadOrdenar({ data, isOk, setIsOk, pistas, setPistas }) {
    const [initialTasks, setInitialTask] = useState(data);
    const [tasks, setTasks] = useState(shuffle(initialTasks));
    //const [isOk, setIsOk] = useState(false);
    useEffect(() => {
        setPistas(0);
        setIsOk(false);
    }, [setIsOk])

    //Manipuladores
    function checkOrder() {
        if (JSON.stringify(tasks) === JSON.stringify(initialTasks)) {
            setIsOk(true);
        } else {
            setIsOk(false);
        }
    }

    //Obtener una pista
    const handleClue = event => {
        setPistas(pistas + 1);
        const items = document.querySelectorAll('.task-item');
        items.forEach((item, index) => {
            const text = item.innerText.trim();
            if (text !== initialTasks[index].text) {
                item.classList.remove('right');
                item.classList.add('wrong');
            } else {
                item.classList.remove('wrong');
                item.classList.add('right');
            }
        });
    };

    return (
        <>
            <DragDropContext
                onDragEnd={(result) => {

                    const { source, destination } = result;
                    if (!destination) {
                        return;
                    }
                    if (
                        source.index === destination.index &&
                        source.droppableId === destination.droppableId
                    ) {
                        return;
                    }

                    setTasks((prevTasks) =>
                        reorder(prevTasks, source.index, destination.index)
                    );
                }}>
                <div className="task-wrapper">
                    <Droppable droppableId="tasks" onChange={checkOrder()}>
                        {(droppableProvided) => (
                            <ul
                                {...droppableProvided.droppableProps}
                                ref={droppableProvided.innerRef}
                                className="task-list">
                                {tasks.map((task, index) => (
                                    <Draggable key={task.id} draggableId={task.id} index={index}>
                                        {(draggableProvided) => (
                                            <li
                                                {...draggableProvided.draggableProps}
                                                ref={draggableProvided.innerRef}
                                                {...draggableProvided.dragHandleProps}
                                                className="task-item">
                                                <img src={task.url}></img>
                                                <span>{task.text}</span>
                                                <div>
                                                    <X />
                                                    <Check />
                                                </div>
                                            </li>
                                        )}
                                    </Draggable>
                                ))}
                                {droppableProvided.placeholder}
                            </ul>
                        )}
                    </Droppable>
                    <div className='task-info'>
                        <h2>Actividad</h2>
                        <p> Tu tarea es elaborar un algoritmo para preparar un huevo frito. Ordena correctamente los pasos de la izquierda para completar el objetivo. </p>
                        <CustomButton onClick={handleClue}><HelpCircle />Obtener una pista</CustomButton>
                    </div>
                </div>
            </DragDropContext>
        </>
    )
}

export default ActividadOrdenar
